import CandidateDashboardPage from "./pages/CandidateManagement/CandidatePages/CandidateDashboardPage";
import CandidateDocumentPage from "./pages/CandidateManagement/CandidatePages/CandidateDocumentPage";
import CandidatePartyAgentPage from "./pages/CandidateManagement/CandidatePages/CandidatePartyAgentPage";
import PoliticalDashboardPage from "./pages/politicalParty/PoliticalPages/PoliticalDashboardPage";
import PoliticalDocumentPage from "./pages/politicalParty/PoliticalPages/PoliticalDocumentPage";
import PoliticalExecutiveMembersPage from "./pages/politicalParty/PoliticalPages/PoliticalExecutiveMembersPage";
import PoliticalPartyAgentPage from "./pages/politicalParty/PoliticalPages/PoliticalPartyAgentPage";
import PoliticalRegisteredElectorsPage from "./pages/politicalParty/PoliticalPages/PoliticalRegisteredElectorsPage";
import PoliticalRegistredAndNonRegisteredPage from "./pages/politicalParty/PoliticalPages/PoliticalRegistredAndNonRegisteredPage";
import PoliticalRepresentativesPage from "./pages/politicalParty/PoliticalPages/PoliticalRepresentativesPage";
import { Reports } from "./pages/reports/Reports";

export const menu = [
    {
        label: "Home",
        items: [
            {
                label: "Dashboard",
                icon: "pi pi-fw pi-home",
                to: "/"
            },
            {
                label: "Agents",
                icon: "pi pi-fw pi-bookmark",
                to: "/party-agent"
            },
            {
                label: "Documents",
                icon: "pi pi-fw pi-bookmark",
                to: "/documents"
            },

            {
                label: "Voter's Register",
                icon: "pi pi-fw pi-bookmark",
                to: "/reports"
            }
        ]
    }
];

export function CandidateSiteGenerateRoutesAndMenu(azureLoginState) {
    var routes = {
        "/": { component: CandidateDashboardPage },
        "/members": { component: PoliticalRegistredAndNonRegisteredPage },
        "/documents": { component: CandidateDocumentPage },
        "/party-agent": { component: CandidatePartyAgentPage },
        "/reports": { component: () =>  <Reports
			isPortal={true} 
			reportType={{
				Name:"Elector Register",
				Type:"registerReports"
			}}/> }
    };

    return { menu: menu, routes: routes };
}
